module.exports = __webpack_public_path__ + "static/media/photo.afa32bb7.png";